import React, { useRef } from 'react';
import styles from './index.module.scss';
import Card from '@components-clean/core/card';
import { Popover } from '@components-clean/core/popover/popover';
import { useHover, useDebouncedValue } from '@hooks-clean/index';

export type SubjectProfileMiniWidgetMultiValueProps = {
    'data-testid': string;
    /* Top-level icon */
    icon: React.ReactNode;
    /* Top-level label */
    label: string;
    items: {
        visible: boolean;
        key: React.Key;
        icon: React.ReactNode;
        label: string;
        value: string | number | null | undefined;
    }[];
};

const SubjectProfileMiniWidgetMultiValue = ({
    'data-testid': dataTestId,
    icon,
    label,
    items,
}: SubjectProfileMiniWidgetMultiValueProps) => {
    const cardRef = useRef<HTMLDivElement>(null);

    const cardHovered = useHover(cardRef);
    const debouncedCardHovered = useDebouncedValue(cardHovered, 300);

    const visibleItems = items.filter((x) => x.visible);

    return (
        <>
            <Card
                ref={(r) => {
                    cardRef.current = r?.element ?? null;
                }}
                data-testid={dataTestId}
                bodyClassName={styles.miniWidgetBody}
            >
                {icon}

                <span className={styles.miniWidgetLabel}>{label}:</span>

                <div className={styles.miniWidgetMultiValueList}>
                    {visibleItems.map((x) => (
                        <div key={x.key} className={styles.miniWidgetMultiValueListItem}>
                            {x.icon}

                            <span className={styles.miniWidgetLabel}>{x.value}</span>
                        </div>
                    ))}
                </div>
            </Card>

            <Popover
                show={debouncedCardHovered}
                data-testid={`${dataTestId}-popover`}
                isInfo={false}
                position="bottom"
                anchor={cardRef.current ?? null}
            >
                <div className={styles.miniWidgetMultiValuePopover}>
                    {visibleItems.map((x) => (
                        <div key={x.key} className={styles.miniWidgetMultiValuePopoverItem}>
                            {x.icon}

                            <span aria-label={x.label}>{x.value}</span>

                            <span>{x.label}</span>
                        </div>
                    ))}
                </div>
            </Popover>
        </>
    );
};

export default SubjectProfileMiniWidgetMultiValue;
